import { useT } from "@transifex/react";
import { useGeneralContext } from "../../context/AppGeneralContext";
import { useLogger } from "../../hooks/useLogger";
import { AreaButton, ButtonColorVariant, ButtonVariant } from "../../complex/teacherArea/AreaButton";
import type { HeaderLink } from "p6m-p6u";

interface AccountDropdownProps {
    dropdownLinks: HeaderLink[];
    hideDropdown: () => void;
    currentPath?: string;
    id: string;
}

const AccountDropdown = (props: AccountDropdownProps) => {
    const { logoutUser } = useGeneralContext();
    const { logEvent } = useLogger();

    const t = useT();

    const t_logout = t("Logout", { _tags: "TeacherArea,Header" });

    const handleLogout = async () => {
        logEvent("Logout Button Clicked", { source: "desktop" });
        await logoutUser();
        props.hideDropdown();
    };

    return (
        <div className="h-full">
            <div
                className="border-stone-400 divide-stone-400 rounded-xsmall-container right-xxs absolute top-[calc(var(--size-header-m)+var(--spacing-xxs))] z-100 flex min-w-[250px] flex-col divide-y border bg-white shadow-sm"
                id={props.id}
            >
                {props.dropdownLinks.map((element) => (
                    <a
                        key={element.link}
                        href={element.link}
                        id={`${element.text}-headerlink`}
                        className="text-stone-1000 first:rounded-t-xsmall-container text-l py-s px-m flex flex-row items-center justify-center group"
                        role="menuitem"
                        onClick={props.hideDropdown}
                    >
                        <p
                            className={`header-nav-link ${
                                element.link === props.currentPath ? "header-nav-link-active" : ""
                            }`}
                        >
                            {element.text}
                        </p>
                    </a>
                ))}
                <div className="py-s px-m flex w-full flex-col">
                    <AreaButton
                        variant={ButtonVariant.SECONDARY}
                        colorVariant={ButtonColorVariant.LUMINA}
                        role="button"
                        onClick={() => void handleLogout()}
                    >
                        {t_logout}
                    </AreaButton>
                </div>
            </div>
        </div>
    );
};

export default AccountDropdown;
